import React from 'react';
import withRouter from '../../Components/Common/withRouter';

const ParticlesAuth = ({ children }) => {
    return (
        <React.Fragment>
            <div className="auth-page-wrapper pt-5auth-page-wrapper new_auth_bg_cover py-5 d-flex justify-content-center align-items-center min-vh-100">
             
                {/* pass the children */}
                {children}

                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-white fw-medium">&copy; {new Date().getFullYear()} LimoGenie Plt. Design by<i className="mdi mdi-heart text-danger"></i> MindzMap</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);